(function () {
  'use strict';

  angular.module('app').component('bookingDetail', bookingDetail());

  function bookingDetail() {
    return {
      bindings: {
        item: '<',
        mode: '<',
        showActionsFromModal: '<', // TODO: campbell - you better use another component to show de booking detail (view only)
        onSavedItem: '&',
        onCanceledItem: '&',
      },
      controller: BookingDetailCtrl,
      controllerAs: 'vm',
      templateUrl: './app/ajs/bookings/booking-detail/booking-detail.component.html',
    };
  }

  BookingDetailCtrl.$inject = [
    'CONFIGURATIONS',
    'UtilService',
    '$location',
    'SessionService',
    'AbilityService',
    'moment',
    'BookingService',
    'BookingItemService',
    'BookingItemNotificationService',
    'ClientService',
    'ClientContactService',
    'GuestService',
    'PriceListService',
    'IncomingPrepaymentService',
    'DocumentTypeService',
    'MeasurementUnitService',
    'ExchangeRateService',
    'ModalWindowConfirmService',
    'OutgoingPrepaymentService',
    'TaxService',
    'ProductService',
    'LocalStoreService',

    // Angular downgraded service
    'companyService',
    'currencyService',
  ];

  function BookingDetailCtrl(
    config,
    UtilService,
    $location,
    SessionService,
    AbilityService,
    moment,
    BookingService,
    BookingItemService,
    BookingItemNotificationService,
    ClientService,
    ClientContactService,
    GuestService,
    PriceListService,
    IncomingPrepaymentService,
    DocumentTypeService,
    MeasurementUnitService,
    ExchangeRateService,
    ModalWindowConfirmService,
    OutgoingPrepaymentService,
    TaxService,
    ProductService,
    LocalStoreService,

    // Angular downgraded service
    companyService,
    currencyService
  ) {
    const vm = this;

    // public properties
    // -----------------------
    vm.UtilService = new UtilService(vm);

    vm.permissions = {
      canCreate: AbilityService.can('create_booking_accountadmin'),
      canUpdate: AbilityService.can('update_booking_accountadmin'),
      canCreateInvoice: AbilityService.can('create_booking_invoice_booking_accountadmin'),
    };

    vm.statusOnCart = 'oncart';
    vm.statusDraft = 'draft';
    vm.statusInvoiced = 'invoiced';
    vm.statusProcessing = 'processing';
    vm.statusConfirmed = 'confirmed';
    vm.statusCancelled = 'cancelled';

    vm.statusPending = 'pending';
    vm.statusRequested = 'requested';

    vm.dateDisplay = config.DATE_DISPLAY_SHORT;
    vm.hourDisplay = config.HOUR_DISPLAY;

    // private properties
    // -----------------------
    const company = SessionService.getSelectedAccountCompany();
    let filterCriteriaOutgoing = OutgoingPrepaymentService.getFilterCriteria();
    let filterCriteriaIncoming = IncomingPrepaymentService.getFilterCriteria();

    let userLanguageCode = SessionService.getUserLanguage().code;

    vm.isDirectClient = false;
    vm.invalidRefNumber = false;

    vm.$onInit = function () {
      setPrePaymentDatePicker(); // Leave it here

      if (vm.item.id) {
        // view - edit
        vm.isElectronicDocument = vm.item.document_type.numbering_type === 'electronic';

        setItemOptions(vm.item, vm.mode);

        vm.lastClientId = vm.item.client_id;

        vm.lastPriceListId = vm.item.price_list_id;
        vm.lastPriceList = vm.item.price_list;

        vm.lastCurrencyId = vm.item.currency_id;
        vm.lastCurrency = vm.item.currency;

        vm.isDirectClient =
          vm.item.client && vm.item.client.client_type
            ? vm.item.client.client_type.predefined
            : false;

        // vm.documentDate = moment(vm.item.created_at); // TODO: created at ?? or service date ??
        vm.documentDate = vm.UtilService.startOfDayFormat(vm.item.created_at); // yyyy-mm-ddT06:00:00.000Z
      } else {
        // new
        vm.createMode = true;

        vm.item = {
          prepayment: false,
          percentage: 0,
          company_id: company.id,
          status: vm.statusDraft,
          user_id: SessionService.currentUser().id,
          booking_items: [],
          guests: [],
        };

        vm.documentDate = moment();

        // Initializers
        getPriceLists();
        getDocumentTypes();
      }

      // Initializers
      getCompany();
    };

    // public methods
    // -----------------------
    vm.isInvalidHeader = function () {
      if (vm.viewMode) return false;

      if (
        vm.sendingForm ||
        !(
          vm.item.client_id &&
          vm.item.language_id &&
          vm.item.currency_id &&
          vm.item.price_list_id &&
          vm.item.sale_channel_id &&
          vm.item.sale_source_id &&
          vm.item.document_type_id
        ) ||
        (!vm.isDirectClient && !vm.item.client_contact_id)
      ) {
        return true;
      }

      return false;
    };

    vm.onClientSelected = function (client) {
      vm.lastClientId = client.id;
      vm.item.client_id = client.id;
      vm.item.client = client;
      vm.item.language_id = vm.item.client.language_id;

      vm.invalidClient = false;

      if (!client.client_profile || !client.client_type) {
        vm.invalidClient = true;
      }

      if (client.client_profile) {
        vm.item.price_list_id = client.client_profile.price_list_id;

        let price_list = vm.priceLists.find(
          (price_list) => price_list.id === vm.item.price_list_id
        );

        vm.selectPriceList(price_list);

        vm.item.currency_id = client.currency_id
          ? client.currency_id
          : vm.item.price_list.currrency_id;
        let currency = vm.currenciesPerCompany.find(
          (currency) => currency.id === vm.item.currency_id
        );

        if (currency) {
          vm.selectCurrency(currency, true);
        }

        vm.isDirectClient = client.client_type.predefined;
      }

      // Get agents except direct client
      if (!vm.isDirectClient) {
        getClientContacts(client.id);

        vm.invalidRefNumber = true;

        if (vm.item.client_contact_id) {
          vm.item.client_contact_id = null;
        }
      }

      vm.clientContactRequired = !vm.isDirectClient ? true : false;
    };

    // When client is empty
    vm.onClientValidated = function (client) {
      vm.item.client = client;

      if (!vm.item.client && vm.item.client_id) {
        resetClientInput();
      }
    };

    vm.onClientCleared = function (clearObj) {
      if (clearObj) {
        vm.item.client = null;
      }

      vm.invalidRefNumber = false;
      vm.invalidClient = false;

      resetClientInput();
    };

    vm.selectPriceList = function (priceList) {
      if (vm.item.status !== vm.statusDraft) return;

      // Same price list is selected
      if (vm.lastPriceListId && vm.lastPriceListId === priceList.id) return;

      const selectPriceListCallback = function () {
        vm.item.price_list = priceList;

        vm.lastPriceListId = priceList.id;
        vm.lastPriceList = priceList;

        if (vm.lastCurrency) {
          vm.selectCurrency(vm.lastCurrency, true);
        }
      };

      // Delete booking items for draft booking if change price list, when the booking has booking items
      //if (vm.item.status === vm.statusDraft && vm.item.booking_items.length > 0) {

      // Delete booking items for draft booking if change price list, when the booking has booking items
      if (vm.item.booking_items.length > 0) {
        // vm.editMode &&
        const successCallback = function (response) {
          vm.item = response;
          vm.originalItem = angular.copy(response);

          selectPriceListCallback();
        };

        const cancelCallback = function () {
          vm.item.price_list_id = vm.lastPriceListId; // Just to keep current price list
          vm.item.price_list = vm.lastPriceList;
        };

        BookingService.changeBookingPriceList(
          vm.item.id,
          vm.item.price_list_id,
          successCallback,
          cancelCallback
        );
      } else {
        // Create
        selectPriceListCallback();
      }
    };

    vm.selectCurrency = function (currency, setCurrency) {
      if (currency && currency.id === vm.lastCurrencyId && !setCurrency) return;

      let selectCurrenyCallback = () => {
        vm.documentDateExchangeRate = getDocumentDateExchangeRate(currency.id);
        // console.log(vm.documentDateExchangeRate);
        // {value: false} // outdated

        vm.item.currency = currency;

        vm.lastCurrencyId = currency.id;
        vm.lastCurrency = currency;

        vm.item.exchange_rate_value = vm.documentDateExchangeRate.exchangeRateValue;

        // if (!vm.documentDateExchangeRate.value) return;
        // console.log(vm.item.exchange_rate_value);
      };

      if (setCurrency) {
        selectCurrenyCallback();
        return;
      }

      if (vm.createMode) {
        selectCurrenyCallback();
      } else if (vm.editMode && vm.item.booking_items.length > 0) {
        let confirmCallback = () => {
          if (vm.item.discount_coupon_id) {
            const successCallback = (response) => {
              vm.item = response;
              vm.item.currency_id = currency.id; // !important

              vm.originalItem = angular.copy(response);

              convertBookingItemsCostAndPrices(currency.id, vm.lastCurrencyId);
              selectCurrenyCallback();
            };

            BookingService.deleteDiscountCoupon(vm.item.id, successCallback, true);
          } else {
            convertBookingItemsCostAndPrices(currency.id, vm.lastCurrencyId);
            selectCurrenyCallback();
          }
        };

        let cancelCallback = () => {
          vm.item.currency_id = vm.lastCurrencyId; // Just to keep current currency
          vm.item.currency = vm.lastCurrency;
        };

        let modalParams = {
          title: 'CHANCE_CURRENCY',
          body: 'CHANCE_CURRENCY_WARNING',
          mode: 'danger',
        };

        ModalWindowConfirmService.open(modalParams, confirmCallback, cancelCallback);
      }
    };

    vm.setTodayExchangeRate = function () {
      let currency;
      if (vm.item.currency.enable_automatic_exchange_rate) {
        currency = vm.item.currency;
      } else {
        currency = vm.item.price_list.currency;
      }

      // vm.item.currency

      vm.settingTodayExchangeRate = true;

      currencyService
        .setAutomaticExchangeRate(currency, vm.companyTimeZoneUtc)
        .subscribe((response) => {
          if (response) {
            // Success
            vm.documentDateExchangeRate.exchangeRateValue = response.todayExchangeRate.rate;
            vm.item.exchange_rate_value = vm.documentDateExchangeRate.exchangeRateValue;
          }

          vm.settingTodayExchangeRate = false;
        });
    };

    vm.selectSaleChannel = function (saleChannel) {
      if (vm.item.status === vm.statusCancelled) return;

      if (saleChannel.is_website) {
        vm.item.website_id = saleChannel.website_id;
        return;
      }

      delete vm.item['website_id'];
    };

    vm.selectDocumentType = function (documentType) {
      if (documentType.id === vm.lastDocumentTypeId) return;

      vm.documentType = documentType;
      vm.lastDocumentTypeId = documentType.id;
    };

    // TODO: We can call the api with more info to avoid extra queries for invoice/client
    vm.openClientInfoModal = function (client) {
      ClientService.openClientInfoModal(client);
    };

    vm.openClientFastCreate = function () {
      let successCallBack = function (client) {
        // vm.selectClient(client);
        vm.onClientSelected(client);
      };

      ClientService.openClientFastCreate({}, successCallBack);
    };

    vm.addContactToClient = function () {
      if (!vm.item.client || vm.item.status === vm.statusCancelled) {
        return;
      }

      let successCallback = function (item) {
        vm.clientContacts.push(item);
      };

      ClientContactService.openClientContactModal(
        {},
        vm.item.client,
        'create',
        true,
        successCallback
      );
    };

    vm.onBookingGuestSaved = function (guestsObj) {
      vm.item.guests = guestsObj;
      vm.originalItem.guests = guestsObj;
    };

    vm.getBooking = function () {
      BookingService.getBooking(vm.item.id).then(function (data) {
        vm.item = data;

        setItemOptions(vm.item, vm.mode);
        setBookingItems();
      });
    };

    vm.editBooking = function () {
      const successCallback = (data) => {
        hideWarningMessageModal(data);

        vm.editMode = true;
        vm.viewMode = false;

        vm.invalidRefNumber = true;

        getPriceLists();
        getDocumentTypes();

        if (vm.item.reference_number === 'N/D') {
          vm.item.reference_number = '';
        }

        if (vm.companyCurrencyIds) {
          getCurrencies(vm.companyCurrencyIds);
        }

        if (vm.item.client && vm.item.client.client_type) {
          vm.isDirectClient = vm.item.client.client_type.predefined;
          vm.clientContacts = vm.item.client.client_contacts;
        } else {
          getClientContacts(vm.item.client.id);
        }
      };

      let cancelCallback = (data) => {
        hideWarningMessageModal(data);
        vm.cancelEdit();
      };

      const showRelatedTransactionsCallback = (data) => {
        hideWarningMessageModal(data);
        BookingService.openRelatedTransactions(vm.item, vm.item.client);
      };

      BookingService.hasRelatedTransactions(vm.item.id, vm.item.client.id).then(function (data) {
        if (data && !SessionService.isWarningMessageHidden('bookings')) {
          let modalParams = {
            mode: 'warning',
            title: 'RECORD_WITH_RELATED_TRANSACTION',
            relatedTransactionButtonLabel: 'VIEW_RELATED_TRANSACTIONS',
            confirmButtonLabel: 'YES',
            cancelButtonLabel: 'NO',
            body: '',
          };

          ModalWindowConfirmService.open(
            modalParams,
            successCallback,
            cancelCallback,
            showRelatedTransactionsCallback
          );
        } else {
          successCallback(data);
        }
      });
    };

    vm.cancelEdit = function () {
      vm.item = vm.originalItem;

      setItemOptions(vm.item);
      setBookingItems();
    };

    vm.saveBooking = function (isFormValid, status) {
      vm.formErrors = false;

      if (!isFormValid) {
        vm.formErrors = true;
        vm.UtilService.scrollToTop();

        return;
      }

      let mode = '';

      if (status) {
        vm.item.status = status;
        mode = 'edit';
      }

      if (!vm.item.prepayment) {
        vm.item.prepayment_date = null;
      }

      createBooking({}, mode);
    };

    vm.cancel = function () {
      /*
      if (vm.editMode) {
        vm.cancelEdit();
        return;
      }
      */

      vm.onCanceledItem();
    };

    vm.selectBookingHistory = function () {
      // vm.bookingHistories = null;

      vm.loadingBookingHistory = true;
      BookingService.getBookingHistory(vm.item.id, { skip_check_role: true }).then(function (data) {
        vm.bookingHistories = data;

        vm.showBookingHistories = true;
        vm.loadingBookingHistory = false;
      });
    };

    vm.getIncomingPrepayments = function () {
      filterCriteriaIncoming.by_booking_id = vm.item.id;
      filterCriteriaIncoming.sortedBy = 'incoming_consecutive';

      vm.loadIngIncomingPrepayments = true;
      IncomingPrepaymentService.getPrepayments(filterCriteriaIncoming).then(function (data) {
        // console.log(IncomingPrepaymentService.items);
        vm.incomingPrepayments = data.items.sort((a, b) => (a.due_date > b.due_date ? 1 : -1));

        vm.showIncomingPrepayments = true;
        vm.loadIngIncomingPrepayments = false;
      });
    };

    vm.getOutgoingPrepayments = function () {
      filterCriteriaOutgoing.by_booking_id = vm.item.id;
      filterCriteriaOutgoing.sortedBy = 'outgoing_consecutive';

      vm.loadingOutgoingPrepayments = true;
      OutgoingPrepaymentService.getPrepayments(filterCriteriaOutgoing).then(function (data) {
        vm.outgoingPrepayments = data.items;

        vm.showOutgoingPrepayments = true;
        vm.loadingOutgoingPrepayments = false;
      });
    };

    vm.openBookingChangeStatus = function () {
      let successCallback = function (bookingObj) {
        vm.item = bookingObj; // test it
        // setBookingItems();

        // vm.getBooking(); // Check if needed vm.item.id
      };

      BookingService.openBookingChangeStatus(vm.item, successCallback);
    };

    vm.deleteBooking = function (booking) {
      if (!(booking.status === vm.statusDraft || booking.booking_items.length === 0)) {
        return;
      }

      let successCallback = function () {
        vm.onCanceledItem();
      };

      BookingService.deleteBooking(booking, successCallback);
    };

    vm.createInvoiceFromBooking = function () {
      let successCallback = function (bookingData) {
        LocalStoreService.set('bookingData', JSON.stringify(bookingData));

        $location.path('/invoices/new').search({
          bookingData: bookingData,
          mode: 'create',
          // fromBooking: true,
        });
      };

      BookingService.createBookingInvoice(vm.item.id, successCallback);
    };

    vm.addBookingItem = function (productType) {
      if (vm.isInvalidHeader() || !vm.documentDateExchangeRate.exchangeRateValue) return;

      vm.addItemPopoverIsOpen = false;

      let successCallback = function (bookingItemObj) {
        if (vm.item.id) {
          // edit
          saveBookingItem(bookingItemObj);
          return;
        }

        // new booking
        createBooking(bookingItemObj);
      };

      BookingItemService.openBookingItemDetail(
        productType,
        {},
        vm.item,
        vm.documentDateExchangeRate,
        vm.currenciesPerCompany,
        vm.companyBaseCurrencyId,
        successCallback
      );
    };

    vm.editBookingItem = function (booking_item) {
      if (!vm.viewMode && vm.item.status !== vm.statusCancelled) {
        BookingItemService.openBookingItemDetail(
          booking_item.booking_type,
          booking_item,
          vm.item,
          vm.documentDateExchangeRate,
          vm.currenciesPerCompany,
          vm.companyBaseCurrencyId,
          saveBookingItem
        );
      }
    };

    vm.deleteBookingItem = function (bookingItem) {
      if (!vm.permissions.canUpdate || !vm.editMode || vm.item.invoice_status !== 'not_related') {
        return;
      }

      // TODO: if the booking item is confirmed and exists a provider notification
      // the app must alert the user. booking item / booking item service items

      let successCallback = function (response) {
        vm.item = response; // reload item
        vm.originalItem = angular.copy(response);

        setBookingItems();
      };

      BookingItemService.deleteBookingItem(bookingItem, vm.item.id, successCallback);
    };

    vm.openEditBookingItemProvider = function (booking_item) {
      let successCallback = function (bookingItemObj) {
        saveBookingItem(bookingItemObj);
      };

      if (!booking_item.based_on_service_items) {
        BookingItemService.openBookingItemStandardCostBased(
          booking_item,
          vm.item,
          vm.documentDateExchangeRate,
          successCallback
        );
      } else {
        BookingItemService.openBookingItemServiceItemsCostBased(
          booking_item,
          vm.item,
          vm.documentDateExchangeRate,
          successCallback
        );
      }
    };

    vm.downloadBookingItemVoucher = function (booking_item) {
      if (vm.item.status !== vm.statusConfirmed) return;

      const params = {
        company_id: vm.item.company_id,
        skip_check_role: true,
      };

      BookingItemService.downloadBookingItemVoucher(booking_item, params);
    };

    vm.openSendBookingItemVoucherToClient = function (booking_item) {
      if (vm.item.status !== vm.statusConfirmed) return;

      BookingItemService.openSendBookingItemVoucherToClient(booking_item, vm.item, {});
    };

    // Booking item notifications

    vm.openUpdateBookingItemNotification = function (booking_item) {
      if (
        !vm.permissions.canUpdate ||
        !vm.editMode ||
        !(
          !booking_item.based_on_service_items &&
          vm.item.status !== vm.statusDraft &&
          vm.item.invoice_status === 'not_related'
        )
      ) {
        return;
      }

      let successCallback = function (dataObj) {
        booking_item.notification = dataObj.notification;
        booking_item.status = dataObj.booking_item_status;
        booking_item.confirmation_status_mode = dataObj.booking_item_confirmation_status_mode;

        vm.item.status = dataObj.booking_status;

        checkAllBokingItemsConfirmed();
      };

      BookingItemNotificationService.openUpdateBookingItemNotification(
        vm.item,
        booking_item,
        null,
        booking_item.notification,
        successCallback
      );
    };

    vm.openBookingItemNotificationInfo = function (booking_item) {
      BookingItemNotificationService.openBookingItemNotificationInfo(
        vm.item,
        booking_item,
        null,
        booking_item.notification
      );
    };

    vm.fastConfirmationBookingItem = function (booking_item) {
      if (
        !vm.permissions.canUpdate ||
        !vm.editMode ||
        vm.item.status === vm.statusDraft ||
        vm.item.invoice_status !== 'not_related' ||
        booking_item.based_on_service_items ||
        booking_item.status === vm.statusConfirmed
      ) {
        return;
      }

      let notification = booking_item.notification || {};

      confirmationFastBookingItem(notification, booking_item, null);
    };

    vm.openSendBookingItemNotificationToProvider = function (booking_item) {
      if (
        !vm.permissions.canUpdate ||
        vm.item.status === vm.statusDraft ||
        booking_item.based_on_service_items ||
        (booking_item.status !== vm.statusPending && booking_item.status !== vm.statusRequested)
      ) {
        return;
      }

      let successCallback = function (dataObj) {
        booking_item.notification = dataObj.notification;
        booking_item.status = dataObj.booking_item_status;

        vm.item.status = dataObj.booking_status;

        checkAllBokingItemsConfirmed();
      };

      BookingItemNotificationService.openSendBookingItemNotificationToProvider(
        vm.item.company_id,
        booking_item,
        null,
        booking_item.notification,
        successCallback
      );
    };

    vm.editBookingItemPriceCost = function (bookingItem, type) {
      if (
        !vm.permissions.canUpdate ||
        !vm.editMode ||
        // bookingItem.status === vm.statusConfirmed ||
        bookingItem.status === vm.statusCancelled
      ) {
        return;
      }

      let successCallback = function ($bookingItem) {
        saveBookingItem($bookingItem); // we can update the booking item in the component and callback
      };

      if (type === 'price') {
        BookingItemService.openBookingItemEditPrice(bookingItem, vm.item, successCallback);
      } else {
        BookingItemService.openBookingItemEditCost(bookingItem, vm.item, successCallback);
      }
    };

    vm.openDocumentProductTaxesExonerations = function (bookingItem) {
      if (vm.viewMode || bookingItem.tax_price === 0) return;

      const successCallBack = function ($bookingItem) {
        calculateBookingItemTotals(bookingItem, $bookingItem.transaction_taxes);
      };

      ProductService.openDocumentProductTaxesExonerations(
        bookingItem,
        vm.item.currency,
        'both',
        successCallBack
      );
    };

    // Bookig item service item notifications

    vm.openUpdateBookingItemServiceItemNotification = function (
      booking_item,
      booking_item_service_item
    ) {
      if (
        !vm.permissions.canUpdate ||
        !vm.editMode ||
        !(vm.item.status !== vm.statusDraft && vm.item.invoice_status === 'not_related')
      ) {
        return;
      }

      let successCallback = function (dataObj) {
        booking_item_service_item.notification = dataObj.notification;
        booking_item_service_item.confirmation_status_mode =
          dataObj.booking_item_service_item_confirmation_status_mode;
        booking_item_service_item.status = dataObj.booking_item_service_item_status;
        booking_item.status = dataObj.booking_item_status;

        vm.item.status = dataObj.booking_status;

        checkAllBokingItemsConfirmed();
      };

      BookingItemNotificationService.openUpdateBookingItemNotification(
        vm.item,
        booking_item,
        booking_item_service_item,
        booking_item_service_item.notification,
        successCallback
      );
    };

    vm.openBookingItemServiceItemNotificationInfo = function (
      booking_item,
      booking_item_service_item
    ) {
      BookingItemNotificationService.openBookingItemNotificationInfo(
        vm.item,
        booking_item,
        booking_item_service_item,
        booking_item_service_item.notification
      );
    };

    vm.fastConfirmationBookingItemService = function (booking_item, booking_item_service_item) {
      if (
        !vm.editMode ||
        !vm.permissions.canUpdate ||
        vm.item.status === vm.statusDraft ||
        vm.item.invoice_status !== 'not_related' ||
        booking_item_service_item.status === vm.statusConfirmed
      )
        return;

      let notification = booking_item_service_item.notification || {};

      confirmationFastBookingItem(notification, booking_item, booking_item_service_item);
    };

    vm.openSendBookingItemServiceItemNotificationToProvider = function (
      booking_item,
      booking_item_service_item
    ) {
      if (
        !vm.permissions.canUpdate ||
        vm.item.status === vm.statusDraft ||
        (booking_item_service_item.status !== vm.statusPending &&
          booking_item_service_item.status !== vm.statusRequested)
      ) {
        return;
      }

      let successCallback = function (dataObj) {
        booking_item_service_item.notification = dataObj.notification;
        booking_item_service_item.status = dataObj.booking_item_service_item_status;
        booking_item.status = dataObj.booking_item_status;

        vm.item.status = dataObj.booking_status;

        checkAllBokingItemsConfirmed();
      };

      BookingItemNotificationService.openSendBookingItemNotificationToProvider(
        vm.item.company_id,
        booking_item,
        booking_item_service_item,
        booking_item_service_item.notification,
        successCallback
      );
    };

    vm.openAddBookingItemToGuest = function (booking_item, booking_item_service_item) {
      let successCallback = function (response) {
        vm.item = response;
        setBookingItems();
      };

      GuestService.openAddBookingItemToGuest(
        booking_item,
        booking_item_service_item,
        vm.item,
        successCallback
      );
    };

    vm.openCheckInGuest = function (booking_item, booking_item_service_item) {
      let successCallback = function (response) {
        vm.item = response;
        setBookingItems();
      };

      GuestService.openCheckInGuest(
        booking_item,
        booking_item_service_item,
        vm.item,
        successCallback
      );
    };

    vm.onDiscountCouponSelected = function ($discountCoupont) {
      vm.item.discount_coupon = $discountCoupont;
    };

    vm.onDiscountCouponApplied = function ($booking) {
      vm.item = $booking; // reload item

      setBookingItems();
    };

    vm.onDiscountCouponDeleted = function ($booking) {
      vm.item = $booking; // reload item

      setBookingItems();
    };

    vm.getBookingResources = function () {
      vm.loadingBookingResources = true;
      vm.bookingResources = [];

      vm.showBookingResources = true;
      vm.loadingBookingResources = false;
    };

    vm.onBookingResourcesSaved = function () {
      console.log('onBookingResourcesSaved');
    };

    vm.openEditPickUpTime = function (bookingItem) {
      //  || !vm.editMode
      if (!vm.permissions.canUpdate) return;

      const successCallback = function ($bookingItem) {
        saveBookingItem($bookingItem); // we can update the booking item in the component and callback
      };

      BookingItemService.openBookingItemEditPickUpTime(bookingItem, vm.item, successCallback);
    };

    // private methods
    // -----------------------
    function setItemOptions(item, mode = '') {
      vm.createMode = false;
      vm.editMode = false;
      vm.viewMode = true;

      if (mode === 'edit') {
        vm.editBooking();
      }

      vm.item.prepayment_date = item.prepayment ? moment(item.prepayment_date) : moment();

      vm.originalItem = angular.copy(item); // store server data
    }

    function setPrePaymentDatePicker() {
      vm.prepaymentDatePickerOptions = {
        singleDatePicker: true,
        minDate: moment(),
        maxDate: moment(vm.item.start_date),
        locale: {
          format: vm.dateDisplay,
        },
        eventHandlers: {
          'hide.daterangepicker': function (ev, picker) {
            // Clear invalid input
            if (vm.item.prepayment_date && !vm.item.prepayment_date._isValid) {
              vm.item.prepayment_date = '';
              vm.paymentDateOptions.minDate = moment();
            }
          },
        },
      };
    }

    // Initializers
    function getCompany() {
      vm.loadingCurrenciesPerCompany = true;

      vm.loadingCompany = true;
      vm.loadingBookingItems = true; // !important

      companyService
        .getCompany(vm.item.company_id, {
          skip_check_role: true,
          lang: userLanguageCode,
        })
        .subscribe((response) => {
          vm.company = response; // to use it after saving

          setCompanySaleChannelsAndSaleSources(vm.company.sale_channels);

          vm.companyBaseCurrencyId = vm.company.currency_id;
          vm.companyCurrencyIds = vm.company.currency_ids;
          vm.companyTimeZoneUtc = vm.company.time_zone.utc;

          // Create / Edit
          if (!vm.viewMode) {
            getCurrencies(vm.companyCurrencyIds);
          }

          // View / Edit
          if (!vm.createMode) {
            vm.user = vm.company.users.find((item) => item.id === vm.item.user_id);

            setBookingItems();
          }

          vm.loadingCompany = false;
        });
    }

    function getPriceLists() {
      if (vm.priceLists) return;

      let params = {
        get: 'active',
        contact_type: 'client',
        skip_check_role: true,
      };

      vm.loadingPriceLists = true;
      PriceListService.getPriceLists(params).then(function (data) {
        vm.priceLists = data.items;

        // TODO: Preload default price list on create - conflict with client profile default price list

        if (!vm.createMode) {
          vm.item.price_list = vm.priceLists.find(
            (priceList) => priceList.id === vm.item.price_list_id
          );
        }

        vm.loadingPriceLists = false;
      });
    }

    function getCurrencies(companyCurrencyIds) {
      if (vm.currenciesPerCompany) return;

      let params = {
        get: 'per_company',
        'currency_ids[]': companyCurrencyIds,
        skip_check_role: true,
        time_zone_utc: vm.companyTimeZoneUtc,
        // documentDate: null,
      };

      if (!vm.createMode) {
        params.documentDate = vm.documentDate;
      }

      currencyService.getCurrencies(params).subscribe((response) => {
        vm.currenciesPerCompany = response;

        if (vm.editMode) {
          vm.selectCurrency(vm.item.currency, true);
        }

        vm.loadingCurrenciesPerCompany = false;
      });
    }

    function getDocumentTypes() {
      if (vm.documentTypes) return;

      let params = {
        get: 'active',
        transaction_type: 'bookings',
        skip_check_role: true,
      };

      vm.loadingDocumentTypes = true;
      DocumentTypeService.getDocumentTypes(params).then(function (data) {
        vm.documentTypes = data.items;

        // Preload default document type on create
        if (vm.createMode) {
          vm.documentType = vm.documentTypes.find((documentType) => documentType.is_default);
          vm.item.document_type_id = vm.documentType.id;
        } else {
          vm.documentType = vm.documentTypes.find(
            (documentType) => documentType.id === vm.item.document_type_id
          );
        }

        vm.lastDocumentTypeId = vm.documentType.id;

        vm.isElectronicDocument = vm.documentType.numbering_type === 'electronic';

        vm.loadingDocumentTypes = false;
      });
    }

    // TODO: dry
    function setCompanySaleChannelsAndSaleSources(saleChannels) {
      vm.saleChannels = [];
      vm.saleSources = [];

      if (!saleChannels) return;

      saleChannels.forEach(function (channel) {
        if (channel.status === 'active') {
          // Sale channels
          if (channel.is_channel) {
            // it does push only channels when it is not website, the website channel is used only on TIM WEBSITE
            if (!channel.is_website) {
              vm.saleChannels.push(channel);
            }

            // it shows website name on edit and show mode /
            // select the first channel when the default by the company is a website channel
            if (vm.createMode && channel.is_default_channel && !channel.is_website) {
              // Select default sale channel when it is not a website
              vm.item.sale_channel_id = channel.id;
            } else if (vm.item.sale_channel_id === channel.id) {
              vm.saleChannel = channel;
            }

            // selects an option when there is a book via ia a website
            if (!vm.item.sale_channel_id && vm.createMode && vm.saleChannels.length > 0) {
              vm.item.sale_channel_id = channel.id;
            }
          }

          // Sale sources
          if (channel.is_source) {
            vm.saleSources.push(channel);

            if (vm.createMode && channel.is_default_source) {
              // Select default sale source
              vm.item.sale_source_id = channel.id;
            } else if (vm.item.sale_source_id === channel.id) {
              vm.saleSource = channel;
            }
          }
        }
      });
    }

    function resetClientInput() {
      vm.item.client_id = null;
      vm.item.language_id = null;
      vm.item.currency_id = null;
      vm.item.price_list_id = null;
    }

    function getDocumentDateExchangeRate(currencyId) {
      return ExchangeRateService.getDocumentDateExchangeRate(
        vm.currenciesPerCompany,
        vm.companyBaseCurrencyId,
        currencyId,
        vm.item.price_list.currency_id
      );
    }

    function getClientContacts(clientId) {
      vm.loadingClientContacts = true;
      ClientContactService.getClientContacts(clientId, { get: 'active' }).then(function (data) {
        vm.clientContacts = data;

        if (vm.createMode) {
          let defaultContact = vm.clientContacts.find((contact) => contact.is_default === true);
          if (defaultContact) {
            vm.item.client_contact_id = defaultContact.id;
          }
        }

        vm.loadingClientContacts = false;
      });
    }

    // Create / Update
    function createBooking(booking_item, mode = '') {
      // TODO: willy consider removing unnecessary params - like invoice
      let params = {
        booking: vm.item,
        booking_item: null,
      };

      // if (!vm.item.reference_number) {
      //   vm.item.reference_number = 'N/D'; // use default in the api.
      // }

      if (booking_item) {
        // for the first booking item
        params.booking_item = booking_item;
      }

      // console.log(params);
      // return;

      vm.sendingForm = true;
      BookingService.saveBooking(params).then(function (data) {
        let status = data.status;
        let response = data.response;

        if (status) {
          // success
          // var mode = !vm.item.id ? 'edit' : ''; // For new bookings we keep the edit mode view

          if (!vm.item.id) {
            // create
            // vm.item = response; // reload item - needed to keep on the same page
            vm.onSavedItem({ item: response });
          } else {
            setItemOptions(response, mode);
            setCompanySaleChannelsAndSaleSources(vm.company.sale_channels);

            // vm.user = vm.UtilService.findItemInArray(vm.company.users, 'id', response.user_id);
            vm.user = vm.company.users.find((user) => user.id === response.user_id);

            setBookingItems();
          }
        } else {
          vm.formErrors = true;
        }

        vm.UtilService.scrollToTop();
        vm.sendingForm = false;
      });
    }

    // Create/update booking item
    function saveBookingItem(booking_item) {
      vm.editMode = true;

      BookingItemService.saveBookingItem(booking_item, vm.item.id).then(function (data) {
        let status = data.status;
        let response = data.response;

        if (status) {
          vm.item = response; // reload item

          vm.originalItem = angular.copy(response);

          setBookingItems();
        }
      });
    }

    // Set related data to each booking item / booking item service item
    // Calculate markup
    function setBookingItems() {
      vm.loadingBookingItems = false;

      if (vm.item.booking_items.length === 0) return;

      // let totalBookingItemsConfirmed = 0;
      let bookingItemMeasurementUnits;
      let bookingItemServiceItemMeasurementUnits;

      vm.item.booking_items.forEach(function (booking_item) {
        bookingItemMeasurementUnits = MeasurementUnitService.setMeasurementUnitsByProductType(
          vm.company.measurement_units,
          booking_item.booking_type
        );

        booking_item.measurement_unit = vm.UtilService.findItemInArray(
          bookingItemMeasurementUnits,
          'id',
          booking_item.measurement_unit_id
        );

        if (booking_item.based_on_service_items && booking_item.booking_item_service_items) {
          booking_item.booking_item_service_items.forEach(function (booking_item_service_item) {
            bookingItemServiceItemMeasurementUnits =
              MeasurementUnitService.setMeasurementUnitsByProductType(
                vm.company.measurement_units,
                'service_item'
              );

            booking_item_service_item.measurement_unit = vm.UtilService.findItemInArray(
              bookingItemServiceItemMeasurementUnits,
              'id',
              booking_item_service_item.measurement_unit_id
            );
          });
        }

        booking_item.marckupTotal = vm.UtilService.roundNum(
          booking_item.subtotal_price - booking_item.subtotal_cost
        ); // total_price total_cost TODO: include taxes ?
        booking_item.marckupPercentage =
          (booking_item.marckupTotal / booking_item.subtotal_cost) * 100; // total_cost
        booking_item.isPastDue = moment(booking_item.start_date) < moment();
      });

      checkAllBokingItemsConfirmed();

      vm.bookingMarkupTotal = vm.UtilService.roundNum(
        vm.item.subtotal_price - vm.item.subtotal_cost
      );
      vm.bookingMarkupPercentage = (vm.bookingMarkupTotal / vm.item.subtotal_cost) * 100;
    }

    function checkAllBokingItemsConfirmed() {
      let totalBookingItemsConfirmed = vm.item.booking_items.filter(
        (x) => x.status === vm.statusConfirmed
      ).length;

      vm.allBookingItemsNotConfirmed =
        totalBookingItemsConfirmed < vm.item.booking_items.length ? true : false;
    }

    function calculateBookingItemTotals(booking_item, transaction_taxes) {
      // Costs
      // ---------
      let productPurchaseTaxes = transaction_taxes.filter((tax) => tax.scope_type === 'purchases');

      let discount_cost = 0;
      let subtotal_cost = booking_item.subtotal_cost;
      let tax_cost_percentage = TaxService.getProductTaxesTotalPercentage(productPurchaseTaxes);
      let tax_exoneration_cost_percentage =
        TaxService.getProductTaxesTotalExonerationPercentage(productPurchaseTaxes);
      let net_tax_cost_percentage = tax_cost_percentage - tax_exoneration_cost_percentage;

      booking_item.purchase_taxes = TaxService.setProductTaxesAmounts(
        subtotal_cost,
        productPurchaseTaxes
      );

      let tax_cost = TaxService.getProductTaxesTotalAmount(booking_item.sale_taxes);
      let tax_exoneration_cost = TaxService.getProductTaxesTotalExonerationAmount(
        booking_item.sale_taxes
      );
      let net_tax_cost = tax_cost - tax_exoneration_cost;

      let total_cost = subtotal_cost + net_tax_cost;

      booking_item.discount_cost = vm.UtilService.roundNum(discount_cost);
      booking_item.subtotal_cost = vm.UtilService.roundNum(subtotal_cost);
      booking_item.tax_cost_percentage = tax_cost_percentage;
      booking_item.tax_cost = vm.UtilService.roundNum(tax_cost);
      booking_item.tax_exoneration_cost_percentage = tax_exoneration_cost_percentage;
      booking_item.tax_exoneration_cost = vm.UtilService.roundNum(tax_exoneration_cost);
      booking_item.net_tax_cost_percentage = net_tax_cost_percentage;
      booking_item.net_tax_cost = vm.UtilService.roundNum(net_tax_cost);
      booking_item.total_cost = vm.UtilService.roundNum(total_cost);

      // Prices
      // ---------
      let productSaleTaxes = transaction_taxes.filter((tax) => tax.scope_type === 'sales');

      let discount_price = 0;
      let subtotal_price = booking_item.subtotal_price;
      let tax_price_percentage = TaxService.getProductTaxesTotalPercentage(productSaleTaxes);
      let tax_exoneration_price_percentage =
        TaxService.getProductTaxesTotalExonerationPercentage(productSaleTaxes);
      let net_tax_price_percentage = tax_price_percentage - tax_exoneration_price_percentage;

      if (vm.item.discount_coupon_id) {
        if (vm.item.discount_coupon.discount_type === 'percentage') {
          discount_price = subtotal_price * (vm.item.discount_coupon.value / 100);
          subtotal_price = subtotal_price - discount_price;
        } else {
          discount_price = vm.item.discount_coupon.value;
          subtotal_price = subtotal_price - discount_price / (net_tax_price_percentage / 100 + 1);
        }
      }

      booking_item.sale_taxes = TaxService.setProductTaxesAmounts(subtotal_price, productSaleTaxes);

      let tax_price = TaxService.getProductTaxesTotalAmount(booking_item.sale_taxes);
      let tax_exoneration_price = TaxService.getProductTaxesTotalExonerationAmount(
        booking_item.sale_taxes
      );
      let net_tax_price = tax_price - tax_exoneration_price;

      let total_price = subtotal_price + net_tax_price;

      booking_item.discount_price = vm.UtilService.roundNum(discount_price);
      booking_item.subtotal_price = vm.UtilService.roundNum(subtotal_price);
      booking_item.tax_price_percentage = tax_price_percentage;
      booking_item.tax_price = vm.UtilService.roundNum(tax_price);
      booking_item.tax_exoneration_price_percentage = tax_exoneration_price_percentage;
      booking_item.tax_exoneration_price = vm.UtilService.roundNum(tax_exoneration_price);
      booking_item.net_tax_price_percentage = net_tax_price_percentage;
      booking_item.net_tax_price = vm.UtilService.roundNum(net_tax_price);
      booking_item.total_price = vm.UtilService.roundNum(total_price);

      let transactionTaxes = booking_item.purchase_taxes.concat(booking_item.sale_taxes);

      if (transactionTaxes.length > 0) {
        booking_item.transaction_taxes = transactionTaxes;
      }

      saveBookingItem(booking_item);
    }

    function convertBookingItemsCostAndPrices(currencyId, lastCurrencyId) {
      // TODO: unexpected behaviour - FIX decimals

      let applyExchangeRateConversion = (amount) =>
        ExchangeRateService.applyExchangeRateConversion(
          amount,
          vm.documentDateExchangeRateForConversions
        );

      // For conversions
      vm.documentDateExchangeRateForConversions =
        ExchangeRateService.getDocumentDateExchangeRateForConversions(
          vm.currenciesPerCompany,
          vm.companyBaseCurrencyId,
          currencyId,
          lastCurrencyId
        );

      // console.log(vm.documentDateExchangeRateForConversions);

      // Costs
      vm.item.total_item_costs = applyExchangeRateConversion(vm.item.total_item_costs);
      vm.item.total_base_costs = applyExchangeRateConversion(vm.item.total_base_costs);
      vm.item.total_net_costs = applyExchangeRateConversion(vm.item.total_net_costs);
      vm.item.total_extra_costs = applyExchangeRateConversion(vm.item.total_extra_costs);
      vm.item.total_discount_costs = applyExchangeRateConversion(vm.item.total_discount_costs);
      vm.item.subtotal_cost = applyExchangeRateConversion(vm.item.subtotal_cost);
      vm.item.total_tax_costs = applyExchangeRateConversion(vm.item.total_tax_costs);
      vm.item.total_tax_exoneration_costs = applyExchangeRateConversion(
        vm.item.total_tax_exoneration_costs
      );
      vm.item.total_net_tax_costs = applyExchangeRateConversion(vm.item.total_net_tax_costs);
      vm.item.total_cost = applyExchangeRateConversion(vm.item.total_cost);

      // Prices
      vm.item.total_item_prices = applyExchangeRateConversion(vm.item.total_item_prices);
      vm.item.total_base_prices = applyExchangeRateConversion(vm.item.total_base_prices);
      vm.item.total_net_prices = applyExchangeRateConversion(vm.item.total_net_prices);
      vm.item.total_extra_prices = applyExchangeRateConversion(vm.item.total_extra_prices);
      vm.item.total_discount_prices = applyExchangeRateConversion(vm.item.total_discount_prices);
      vm.item.subtotal_price = applyExchangeRateConversion(vm.item.subtotal_price);
      vm.item.total_tax_prices = applyExchangeRateConversion(vm.item.total_tax_prices);
      vm.item.total_tax_exoneration_prices = applyExchangeRateConversion(
        vm.item.total_tax_exoneration_prices
      );
      vm.item.total_net_tax_prices = applyExchangeRateConversion(vm.item.total_net_tax_prices);
      vm.item.total_price = applyExchangeRateConversion(vm.item.total_price);

      vm.item.booking_items.forEach(function (booking_item) {
        // Costs
        booking_item.adult_cost = applyExchangeRateConversion(booking_item.adult_cost);
        booking_item.child_cost = applyExchangeRateConversion(booking_item.child_cost);
        booking_item.infant_cost = applyExchangeRateConversion(booking_item.infant_cost);
        booking_item.senior_cost = applyExchangeRateConversion(booking_item.senior_cost);
        booking_item.item_cost = applyExchangeRateConversion(booking_item.item_cost);
        booking_item.base_cost = applyExchangeRateConversion(booking_item.base_cost);
        booking_item.net_cost = applyExchangeRateConversion(booking_item.net_cost);
        booking_item.pickup_cost = applyExchangeRateConversion(booking_item.pickup_cost);
        booking_item.dropoff_cost = applyExchangeRateConversion(booking_item.dropoff_cost);
        booking_item.discount_cost = applyExchangeRateConversion(booking_item.discount_cost);
        booking_item.subtotal_cost = applyExchangeRateConversion(booking_item.subtotal_cost);
        booking_item.tax_cost = applyExchangeRateConversion(booking_item.tax_cost);
        booking_item.tax_exoneration_cost = applyExchangeRateConversion(
          booking_item.tax_exoneration_cost
        );
        booking_item.net_tax_cost = applyExchangeRateConversion(booking_item.net_tax_cost);
        booking_item.total_cost = applyExchangeRateConversion(booking_item.total_cost);

        // Prices
        booking_item.adult_price = applyExchangeRateConversion(booking_item.adult_price);
        booking_item.child_price = applyExchangeRateConversion(booking_item.child_price);
        booking_item.infant_price = applyExchangeRateConversion(booking_item.infant_price);
        booking_item.senior_price = applyExchangeRateConversion(booking_item.senior_price);
        booking_item.item_price = applyExchangeRateConversion(booking_item.item_price);
        booking_item.base_price = applyExchangeRateConversion(booking_item.base_price);
        booking_item.commission_price = applyExchangeRateConversion(booking_item.commission_price);
        booking_item.net_price = applyExchangeRateConversion(booking_item.net_price);
        booking_item.pickup_price = applyExchangeRateConversion(booking_item.pickup_price);
        booking_item.dropoff_price = applyExchangeRateConversion(booking_item.dropoff_price);
        booking_item.discount_price = applyExchangeRateConversion(booking_item.discount_price);
        booking_item.subtotal_price = applyExchangeRateConversion(booking_item.subtotal_price);
        booking_item.tax_price = applyExchangeRateConversion(booking_item.tax_price);
        booking_item.tax_exoneration_price = applyExchangeRateConversion(
          booking_item.tax_exoneration_price
        );
        booking_item.net_tax_price = applyExchangeRateConversion(booking_item.net_tax_price);
        booking_item.total_price = applyExchangeRateConversion(booking_item.total_price);

        // For costs and prices
        booking_item.transaction_taxes.forEach((tax) => {
          tax.amount = applyExchangeRateConversion(tax.amount);
        });

        if (
          booking_item.based_on_service_items &&
          booking_item.booking_item_service_items.length > 0
        ) {
          booking_item.booking_item_service_items.forEach((booking_item_service_item) => {
            // Costs
            booking_item_service_item.adult_cost = applyExchangeRateConversion(
              booking_item_service_item.adult_cost
            );

            booking_item_service_item.child_cost = applyExchangeRateConversion(
              booking_item_service_item.child_cost
            );

            booking_item_service_item.infant_cost = applyExchangeRateConversion(
              booking_item_service_item.infant_cost
            );

            booking_item_service_item.senior_cost = applyExchangeRateConversion(
              booking_item_service_item.senior_cost
            );

            booking_item_service_item.item_cost = applyExchangeRateConversion(
              booking_item_service_item.item_cost
            );

            booking_item_service_item.base_cost = applyExchangeRateConversion(
              booking_item_service_item.base_cost
            );

            booking_item_service_item.net_cost = applyExchangeRateConversion(
              booking_item_service_item.net_cost
            );

            booking_item_service_item.discount_cost = applyExchangeRateConversion(
              booking_item_service_item.discount_cost
            );

            booking_item_service_item.subtotal_cost = applyExchangeRateConversion(
              booking_item_service_item.subtotal_cost
            );

            booking_item_service_item.tax_cost = applyExchangeRateConversion(
              booking_item_service_item.tax_cost
            );

            booking_item_service_item.tax_exoneration_cost = applyExchangeRateConversion(
              booking_item_service_item.tax_exoneration_cost
            );

            booking_item_service_item.net_tax_cost = applyExchangeRateConversion(
              booking_item_service_item.net_tax_cost
            );

            booking_item_service_item.total_cost = applyExchangeRateConversion(
              booking_item_service_item.total_cost
            );

            // For costs and prices
            booking_item_service_item.transaction_taxes.forEach((tax) => {
              tax.amount = applyExchangeRateConversion(tax.amount);
            });
          });
        }
      });
    }

    // Booking item || Booking item service item
    function confirmationFastBookingItem(notification, booking_item, booking_item_service_item) {
      notification.status = vm.statusConfirmed;

      let params = {
        company_id: company.id,
        fast_confirmation: true,
      };

      let bookingItemServiceItemId = booking_item_service_item
        ? booking_item_service_item.id
        : null;

      BookingItemNotificationService.saveBookingItemNotification(
        booking_item.booking_id,
        booking_item.id,
        bookingItemServiceItemId,
        notification,
        params
      ).then(function (response) {
        response = response.data;

        if (!response.errors) {
          if (!booking_item_service_item) {
            booking_item.notification = response.notification;
            booking_item.confirmation_status_mode = response.confirmation_status_mode;
          } else {
            booking_item_service_item.notification = response.notification;
            booking_item_service_item.status = response.booking_item_service_item_status;
            booking_item_service_item.confirmation_status_mode = response.confirmation_status_mode;
          }

          booking_item.status = response.booking_item_status;

          vm.item.status = response.booking_status;

          checkAllBokingItemsConfirmed();
        }
      });
    }

    function hideWarningMessageModal(data) {
      if (data) SessionService.hideWarningMessage('bookings', data);
    }
  }
})();
